<template>
    <div class="vh-100 error-page-container pt-3">
        <div class="header mb-5">
            <div class="header">
                <div class="col align-self-center">
                    <Logo/>
                </div>
            </div>
        </div>
        <h1 class="mb-5 text-center">{{errorText}}</h1>
    </div>
</template>

<script>
    import Logo from '../components/Logo';

    export default {
        name: "ErrorPage",
        props: {
            errorText: {
                required: true,
                type: String,
            },
        },
        components: {
            Logo,
        },
        data() {
            return {
                title: '',
                message: '',
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/utils/variables";

    .error-page-container {
        background: $bg-color;
    }

    @media (max-width: 475px) {
        .error-page-container {
            h1 {
                font-size: 2rem;
            }

            h2 {
                font-size: 1.5rem;
            }
        }
    }
</style>
